module.exports = __webpack_public_path__ + "img/165_thumbnail.572663e8.jpg";